(() => {
  const initialise = (picker) => {
    if (picker.dataset.bundleInitialised === 'true') return;
    picker.dataset.bundleInitialised = 'true';
    const buttons = [...picker.querySelectorAll('[data-bundle-mode]')];
    const cards = [...picker.querySelectorAll('[data-bundle-card]')];
    const hint = picker.querySelector('[data-bundle-hint]');

    const setMode = (mode, selectVisible = true) => {
      buttons.forEach((button) => {
        const active = button.dataset.bundleMode === mode;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      cards.forEach((card) => { card.hidden = card.dataset.bundleAudienceValue !== mode; });
      if (hint) hint.innerHTML = mode === 'couple'
        ? '<strong>Couples pack selected.</strong> Two kits, packed together for convenience.'
        : '<strong>Testing with a partner?</strong> Switch to a couples pack and save.';

      if (selectVisible) {
        const checked = picker.querySelector('input[type="radio"]:checked');
        if (!checked || checked.closest('[data-bundle-card]').hidden) {
          const next = cards.find((card) => !card.hidden && !card.querySelector('input').disabled)?.querySelector('input');
          if (next) {
            next.checked = true;
            next.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      }
    };

    buttons.forEach((button) => button.addEventListener('click', () => setMode(button.dataset.bundleMode)));
    const selected = picker.querySelector('input[type="radio"]:checked');
    setMode(selected?.closest('[data-bundle-card]')?.dataset.bundleAudienceValue || 'single', false);
  };

  const initialiseWithin = (root = document) => {
    if (root.matches?.('.bundle-couple-picker')) initialise(root);
    root.querySelectorAll?.('.bundle-couple-picker').forEach(initialise);
  };

  initialiseWithin();
  document.addEventListener('shopify:section:load', (event) => initialiseWithin(event.target));

  // Shopify replaces <variant-selects> after every option change. Re-initialise
  // the replacement picker so its audience tab and visible cards stay in sync.
  if (!window.rapidtestBundlePickerObserver) {
    window.rapidtestBundlePickerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) initialiseWithin(node);
        });
      });
    });
    window.rapidtestBundlePickerObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
